module.exports = __webpack_public_path__ + "img/086879e.jpg";